import { Component } from '@angular/core';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { SiteGeoMappingService } from '../../Model/LocationMaster/SiteGeoMappng/site-geo-mapping.service';
import { SessionService } from '../../Util/Session/session.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import * as XLSX from 'xlsx';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
@Component({
  selector: 'app-branch-geo-mapping',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './branch-geo-mapping.component.html',
  styleUrl: './branch-geo-mapping.component.scss'
})
export class BranchGeoMappingComponent {
  isDisabled: boolean = false;
  BranchMaster: any[] = [];
  BranchGeoMapping: any[] = [];
  rowEnabled: boolean[] = [];
  selectAllRows: boolean = false;
  BranchId: any = null;
  BranchName: string = '';
  public User: any = null;
  BranchGeoData: any[] = [];
  BranchGeoRecord: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  dtoptions: DataTables.Settings = {};
  constructor(private SiteGeoMapService: SiteGeoMappingService,
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private download: DownloadSampleService,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
  }

  onSelectChange(type: string) {
    if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
      this.BranchGeoMapping = []
    }
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }

  add() {
    this.TableFill();
    this.rowEnabled = new Array(this.BranchGeoMapping.length).fill(false);
    this.selectAllRows = false;
  }

  toggleRowEnabled(index: number) {
    this.rowEnabled[index] = !this.rowEnabled[index];
  }

  toggleSelectAllRows() {
    this.selectAllRows = !this.selectAllRows;
    this.rowEnabled = new Array(this.BranchGeoMapping.length).fill(this.selectAllRows);
    this.BranchGeoMapping.forEach(shift => shift.checked = true);
    if (!this.selectAllRows) {
      this.BranchGeoMapping.forEach(shift => shift.checked = false);
    }
  }
  async save() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit) {
        if (result) {
          this.InsertUpdate();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => { });
  }
  TableFill() {
    this.User = this.sessionService.GetUserDetails();
    const SiteGeoMap = {
      UserId: this.User.UserId,
      Type: 'Branch',
      BranchId: this.BranchId,
      ClientID: 0,
      SiteID: 0
    }
    this.isDisabled = true;
    this.SiteGeoMapService.SiteGeoMapLoad(SiteGeoMap).subscribe(
      data => {
        this.BranchGeoMapping = data
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }
  InsertUpdate() {
    if (this.BranchGeoMapping.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    this.User = this.sessionService.GetUserDetails();
    const SiteGeoMap = this.BranchGeoMapping.map(site => {
      return {
        SiteID: site.BranchID,
        Latitude: site.Latitude,
        Longitude: site.Longitude,
        Accuracy: site.Accuracy,
        Altitude: site.Altitude,
        Heading: site.Heading,
        Radius: site.Radius,
        IsAltitudeApplicable: site.IsAltitudeApplicable,
        AltitudeRadius: site.AltitudeRadius,
        isMocked: true,
        Active: true,
        GeoMappingFor: 'B'
      };
    });
    const SiteData = {
      UserId: this.User.UserId,
      Type: 'Branch',
      SiteGeoMappingParameter: SiteGeoMap
    };
    this.SiteGeoMapService.SiteGeoMapInsertUpate(SiteData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          this.BranchGeoMapping = [];
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
        }
        this.BranchId = null;
      },
      error => {
        console.error('Error:', error);
      });
  }

  ValidateInput(event: KeyboardEvent, type: string) {
    const charCode = event.which ? event.which : event.keyCode;
    const input = (event.target as HTMLInputElement).value;
    const dotCount = input.split('.').length - 1;
    const minusCount = (input.match(/-/g) || []).length;
    const cursorPosition = (event.target as HTMLInputElement).selectionStart;

    if (type === 'Latitude') {
      if (
        (charCode !== 46 && charCode !== 45 && (charCode < 48 || charCode > 57)) ||
        (dotCount > 0 && charCode === 46 && (cursorPosition !== null && cursorPosition <= input.indexOf('.') + 1)) ||
        (charCode === 45 && (cursorPosition !== null && cursorPosition !== 0)) ||
        (minusCount > 0 && charCode === 45)
      ) {
        event.preventDefault();
        return;
      }
      if (input.length >= 25) {
        event.preventDefault();
        return;
      }
    }
    else if (type === 'NumandDec') {
      if (
        (charCode !== 46 && charCode !== 45 && (charCode < 48 || charCode > 57)) ||
        (dotCount > 0 && charCode === 46 && (cursorPosition !== null && cursorPosition <= input.indexOf('.') + 1)) ||
        (charCode === 45 && (cursorPosition !== null && cursorPosition !== 0)) ||
        (minusCount > 0 && charCode === 45)
      ) {
        event.preventDefault();
        return;
      }
    }
    else if (type === 'radius') {
      if (
        charCode !== 46 &&
        charCode > 31 &&
        (charCode < 48 || charCode > 57) ||
        (dotCount > 0 && charCode === 46)
      ) {
        event.preventDefault();
      }
    }
  }

  handleFileInput(event: any): void {
    this.BranchGeoRecord.length = 0;
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }
  // processExcelFile(file: File): void {
  //   const reader = new FileReader();
  //   reader.onload = (event) => {
  //     if (event && event.target && event.target.result) {
  //       const binaryString = event.target.result as string;
  //       const workbook = XLSX.read(binaryString, { type: 'binary' });
  //       const sheetName = workbook.SheetNames[0];
  //       const worksheet = workbook.Sheets[sheetName];
  //       const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
  //       const headerRow = excelData[0];
  //       const headers = headerRow.map((header: string) => header.trim());
  //       const dataRows = excelData.slice(1);
  //       const formattedData = dataRows.map((row: any[]) => {
  //         const rowData: any = {};
  //         row.forEach((cellData, index) => {
  //           rowData[headers[index]] = cellData;
  //         });
  //         return rowData;
  //       });
  //       const invalidRowsWithDetails = formattedData.filter((row, rowIndex) => {
  //         let invalidColumns: string[] = [];
  //         for (const column of ['Latitude', 'Longitude', 'Accuracy', 'Altitude', 'Heading', 'Radius']) {
  //           if (typeof row[column] === 'string') {
  //             invalidColumns.push(column);
  //           }
  //         }
  //         if (invalidColumns.length > 0) {
  //           const errorMessage = `Invalid row at index ${rowIndex + 1}: Invalid column - ${invalidColumns.join(', ')}`;
  //           this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
  //           return true;
  //         }
  //         return false;
  //       });
  //       if (invalidRowsWithDetails.length > 0) {
  //         return;
  //       }
  //       this.BranchGeoMapping = [];
  //       formattedData.forEach(row => {
  //         this.BranchGeoMapping.push(row);
  //       });
  //       console.log('Excel data:', this.BranchGeoMapping);
  //     } else {
  //       console.error('Failed to read the file.');
  //     }
  //   };
  //   reader.readAsBinaryString(file);

  // }
  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        const headerRow = excelData[0];
        const headers = headerRow.map((header: string) => header.trim());
        const dataRows = excelData.slice(1);

        const uniqueIds: Set<number> = new Set();
        //const uniqueLocationIds: Set<number> = new Set();
        // const LocationNames: Set<string> = new Set();
        this.BranchGeoRecord = [];

        for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
          const row = dataRows[rowIndex];
          const rowData: any = {};

          row.forEach((cellData, index) => {
            rowData[headers[index]] = cellData;
          });

          //const id = rowData['ESS_SiteGateGeoMappingID'];
          let branchname = rowData['BranchName'].toString();
          let isaltitudeapplicable = rowData['IsAltitudeApplicable'].toString();
          let altituderadius = rowData['AltitudeRadius'];
          // let clientname = rowData['ClientName'].toString();
          // let sitecode = rowData['SiteCode'].toString();
          // let sitename = rowData['SiteName'].toString();

          branchname = branchname ? branchname.trim() : '';
          // clientname = clientname ? clientname.trim() : '';
          // sitecode = sitecode ? sitecode.trim() : '';
          // sitename = sitename ? sitename.trim() : '';

          if (branchname !== '' && branchname !== undefined && uniqueIds.has(branchname)) {
            this.toast.show({ message: `Duplicate Branch Name '${branchname}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          } else {
            uniqueIds.add(branchname);
          }

          if (branchname === '' || branchname === null || branchname === undefined) {
            this.toast.show({ message: `Branch name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }

          // if (clientname === '' || clientname === null || clientname === undefined) {
          //   this.toast.show({ message: `Client name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
          //   return;
          // }
          // if (sitecode === '' || sitecode === null || sitecode === undefined) {
          //   this.toast.show({ message: `Site Code is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
          //   return;
          // }
          // if (sitename === '' || sitename === null || sitename === undefined) {
          //   this.toast.show({ message: `Site name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
          //   return;
          // }
          rowData['BranchName'] = branchname;
          // rowData['ClientName'] = clientname;
          // rowData['SiteCode'] = sitecode;
          // rowData['SiteName'] = sitename;
          rowData['IsMocked'] = true;
          rowData['Active'] = true;
          rowData['GeoMappingFor'] = 'B';
          rowData['IsAltitudeApplicable'] = isaltitudeapplicable.toLowerCase() == 'yes' ? true : false;
          rowData['AltitudeRadius'] = altituderadius;
          this.BranchGeoRecord.push(rowData);
          console.log(this.BranchGeoRecord)
        }
        this.BulkInsertUpdate(this.BranchGeoRecord);
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }
  BulkInsertUpdate(Data: any) {
    this.User = this.sessionService.GetUserDetails();
    if (this.BranchGeoRecord.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    const shiftgroupData = {
      SelectType: 'UPLOAD',
      ESS_BranchGeoMappingBulkInsertUpdate: Data,
      UserId: this.User.UserId,
    };
    this.isDisabled = true;
    this.SiteGeoMapService.ESS_BranchGeoMapping_BlukInsert(shiftgroupData).subscribe(
      data => {
        if (data.Error_Code == '625') {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
        //this.GetData();
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }
  downloadExcel() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    const fileName = 'BranchGeoMappingUpload.xlsx';
    const filePath = 'assets/SampleFormatForUpload/' + fileName;
    link.setAttribute('href', filePath);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }

  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'BranchGeoMappingMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.BranchGeoData = data;
        if (this.BranchGeoData.length > 0) {
          this.download.exportToExcel(this.BranchGeoData, "BranchGeoMapping_data");
          this.isDisabled = false;
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }

  disableAltitude(row: boolean, altitude: boolean): boolean{
    if(row){
      if(altitude){
        return false;
      }else{
        return true;
      }
    }
    return true;
  }
}
